import React from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

export interface IconButtonProps extends ButtonProps {
  icon: React.ElementType;
  isLoading?: boolean;
  srLabel?: string; // Screen reader label for accessibility
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon: Icon, isLoading = false, srLabel, className, size = 'icon', ...props }, ref) => {
    return (
      <Button
        ref={ref}
        size={size}
        className={cn(
          'relative transition-all duration-200',
          {
            'h-8 w-8': size === 'icon' || size === 'sm',
            'h-10 w-10': size === 'default',
            'h-12 w-12': size === 'lg',
          },
          className
        )}
        disabled={isLoading || props.disabled}
        {...props}
      >
        {isLoading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Icon
            className={cn('transition-transform', {
              'h-3.5 w-3.5': size === 'sm',
              'h-4 w-4': size === 'icon' || size === 'default',
              'h-5 w-5': size === 'lg',
            })}
          />
        )}
        {srLabel && <span className="sr-only">{srLabel}</span>}
      </Button>
    );
  }
);

IconButton.displayName = 'IconButton';

export default IconButton;